import { Box, Slider as MuiSlider, SliderProps, Stack, styled, Typography } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  borderRadius: 12,
  border: `1px solid ${theme.palette.grey[200]}`,
  padding: '20px 16px 16px',
}));

export const SliderContainer = styled(Box)({
  padding: '20px 16px 16px',
});

export const Slider = styled((props: SliderProps) => <MuiSlider {...props} />)(({ theme }) => ({
  height: 8,
  borderRadius: 4,
  margin: 0,
  paddingBottom: 6,

  '& .MuiSlider-thumb': {
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: theme.customShadows.md,
    },
    backgroundColor: theme.palette.common.white,
    border: `2px solid ${theme.palette.primary[600]}`,
    height: 22,

    width: 22,
  },

  '& .MuiSlider-markLabel': {
    ...theme.typography['body-2-md'],

    '& *': {
      background: 'transparent',
    },
    '&:before': {
      display: 'none',
    },
    '&[data-index="0"]': {},
    '&[data-index="4"]': {
      right: -50,
    },

    color: theme.palette.grey[700],

    top: -20,
  },

  '& .MuiSlider-track': {
    background: theme.palette.primary[600],
    border: 'none',
  },

  '& .MuiSlider-rail': {
    backgroundColor: theme.palette.grey[200],
    opacity: 1,
  },

  '& .MuiSlider-mark': {
    '&[data-index="0"], &[data-index="4"]': {
      background: 'transparent',
    },
    backgroundColor: '#fff',
    borderRadius: '50%',
    height: 6,
    opacity: 1,

    width: 6,
  },
}));

export const TotalAndPriceContainer = styled(Stack)({
  flexDirection: 'row',
  gap: 8,
  width: '100%',
});

export const TotalContainer = styled(Stack)({
  gap: 5,
  flexGrow: 1,
});

export const PriceContainer = styled(Stack)({
  gap: 5,
});

export const Label = styled(Typography)(({ theme }) => ({
  ...theme.typography['body-2-md'],
  display: 'block',
}));

export const Price = styled(Box)(({ theme }) => ({
  ...theme.typography['body-1'],
  padding: '10px 14px',
  backgroundColor: theme.palette.grey[50],
  borderRadius: 8,
}));
